import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { IWebhookSubscriptionBaseModel } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/row-data";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { webhookSubscriptionsQueryKeys } from "../key-factory/factory";

export const useSaveWebhookSubscriptionMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: webhookSubscriptionsQueryKeys.save(),
        retry: 2,
        retryDelay: 200,
        mutationFn(subscription: IWebhookSubscriptionBaseModel) {
            return salesApiService.management.saveWebhookSubscription(subscription);
        },
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: webhookSubscriptionsQueryKeys.list(),
                refetchType: "inactive",
            });
        },
    });
};
